import { useEffect, useState } from 'react';
import styles from './LiveTicker.module.css';

// 전체 태그 — 처음부터 전부 렌더링되며 layout shift 없음.
// 순환 "flash" 효과만 무작위 순서로 이동.
// TODO(backend): CMS/실데이터 연결 시 이 배열을 fetch로 교체.
const TAGS = [
  '환자 클레임 대응',
  '보건소 조사 입회',
  '악성 리뷰 경고장',
  '직원 분쟁 중재',
  '의료사고 자문',
  '내용증명 발송',
  '행정처분 대응',
  '합의 협상 대행',
  '진료기록 검토',
  '의료광고 심의 자문',
  '행정심판 준비',
  '명예훼손 고소 대응',
];

// flash가 다음 태그로 이동하는 주기 (ms)
const FLASH_INTERVAL = 1400;

export function LiveTicker() {
  // 한 번에 하이라이트되는 태그 인덱스
  const [flashIdx, setFlashIdx] = useState(0);

  useEffect(() => {
    let prev = 0;
    const id = setInterval(() => {
      // 직전과 다른 인덱스를 뽑아 "움직이는" 느낌을 보장
      let next;
      do {
        next = Math.floor(Math.random() * TAGS.length);
      } while (TAGS.length > 1 && next === prev);
      prev = next;
      setFlashIdx(next);
    }, FLASH_INTERVAL);
    return () => clearInterval(id);
  }, []);

  return (
    <section className={styles.section} aria-label="실시간 대응 영역">
      <div className={styles.inner}>
        <div className={styles.liveLabel}>
          <span className={styles.liveStatus}>
            <span className={styles.liveStatusDot} />
            LIVE
          </span>
          지금 이 순간에도 대응 중인 사건
        </div>

        <ul className={styles.ticker}>
          {TAGS.map((text, i) => (
            <li
              key={text}
              className={`${styles.tickerItem} ${i === flashIdx ? styles.tickerItemFlash : ''}`}
            >
              <span className={styles.tickerDot} />
              {text}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
